import { mentionsLegalesText } from './text-mentions-legales';

const { subtitle, textOne, textTwo, textThree, textFour } = mentionsLegalesText;

const MentionsLegales = () => {
  return (
    <section className="legal-block">
      <h2 className="legal-block-title">{subtitle}</h2>
      <p>{textOne}</p>
      <p>{textTwo}</p>
      <p>{textThree}</p>
      <p>{textFour}</p>
    </section>
  );
};

export default MentionsLegales;
